import { render, staticRenderFns } from "./LandingConfigError.vue?vue&type=template&id=e35ed55c"
import script from "./LandingConfigError.vue?vue&type=script&lang=js"
export * from "./LandingConfigError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports